export const mmTableConstants = {
    translationGroup: "_table"
}